module.exports = __webpack_public_path__ + "media/1x1/pf-2a69c581.svg";